const constants = {
  ACTIONS: {
    SET_THEME: "SET_THEME",
    SET_DASHBOARD_SETTINGS: "SET_DASHBOARD_SETTINGS",
    ALL_SETTINGS_LOADED: "ALL_SETTINGS_LOADED"
  } as { [key: string]: SettingsStore.eActionType },
};

export default constants;
